module.exports = {"610630001":"丹州街道","610630101":"秋林镇","610630102":"云岩镇","610630104":"集义镇","610630105":"壶口镇","610630200":"英旺乡","610630201":"交里乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610630.json
// module id = 2844
// module chunks = 0